import { useState } from 'react';
import { getValuableVariables } from '@anytag/shared-utils';
import { ParamsSearchReturnType } from '@anytag/shared-hooks';
import { InstagramInfluencerSearchResultV3, useAllInstagramInfluencersV3Query } from '@anytag/graphql';
import { formatInfluencerProfile } from '../utils';
import { InstagramInfluencersSearchSchemaType, InstagramInfluencersProps } from '../schemaTypes';
import { useGetInfluencersQueryVariables } from '../../hooks';

type Props = Pick<ParamsSearchReturnType<InstagramInfluencersSearchSchemaType>, 'page' | 'limit' | 'filter' | 'sort'> &
  Pick<InstagramInfluencersProps, 'getCurrentProfiles'>;

export const useInstagramInfluencersList = ({ page, sort, limit, filter, getCurrentProfiles }: Props) => {
  // Using data directly from query can be empty if skipSearch is true
  // But we still want to keep old data in that case, so we store it in state
  const [data, setData] = useState<InstagramInfluencerSearchResultV3>();
  const { skipSearch, variables } = useGetInfluencersQueryVariables({ page, limit, filter });
  const { loading } = useAllInstagramInfluencersV3Query({
    skip: skipSearch || !filter,
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    variables: getValuableVariables({ ...variables, orderBy: sort }),
    onCompleted: ({ allInstagramInfluencersV3 }) => {
      setData(allInstagramInfluencersV3);
      getCurrentProfiles?.(allInstagramInfluencersV3.instagramAccounts.map(formatInfluencerProfile));
    }
  });

  return {
    loading,
    totalRecords: data?.totalNumber || 0,
    listRecords: data?.instagramAccounts?.map(formatInfluencerProfile) || []
  };
};
